// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__fyOJ9","dragIcon":"SortableItem_dragIcon__2qeER","disabled":"SortableItem_disabled___T7NE"};